import { notify } from 'utils/reduxUtils';

export const types = {
  ADD_WORK_STEP: 'workflows/workflowsLists/ADD_WORK_STEP',
  DELETE_WORK_STEP_ERROR: 'workflows/workflowsLists/DELETE_WORK_STEP_ERROR',
  DELETE_WORK_STEP_REQUEST: 'workflows/workflowsLists/DELETE_WORK_STEP_REQUEST',
  DELETE_WORK_STEP_SUCCESS: 'workflows/workflowsLists/DELETE_WORK_STEP_SUCCESS',
  EDIT_WORK_STEP: 'workflows/workflowsLists/EDIT_WORK_STEP',
  FETCH_QUOTE_WORKFLOW_ERROR:
    'workflows/workflowsLists/FETCH_QUOTE_WORKFLOW_ERROR',
  FETCH_QUOTE_WORKFLOW_REQUEST:
    'workflows/workflowsLists/FETCH_QUOTE_WORKFLOW_REQUEST',
  FETCH_QUOTE_WORKFLOW_SUCCESS:
    'workflows/workflowsLists/FETCH_QUOTE_WORKFLOW_SUCCESS',
  FETCH_WORK_STEPS_ERROR: 'workflows/workflowsLists/FETCH_WORK_STEPS_ERROR',
  FETCH_WORK_STEPS_REQUEST: 'workflows/workflowsLists/FETCH_WORK_STEPS_REQUEST',
  FETCH_WORK_STEPS_SUCCESS: 'workflows/workflowsLists/FETCH_WORK_STEPS_SUCCESS',
};

export const fetchQuoteWorkflow = {
  request: () => ({
    type: types.FETCH_QUOTE_WORKFLOW_REQUEST,
  }),
  success: ({ quoteWorkflow }) => ({
    type: types.FETCH_QUOTE_WORKFLOW_SUCCESS,
    payload: { quoteWorkflow },
  }),
  error: notify((error) => ({
    type: types.FETCH_QUOTE_WORKFLOW_ERROR,
    payload: { error },
  })),
};

export const fetchWorkSteps = {
  request: () => ({
    type: types.FETCH_WORK_STEPS_REQUEST,
  }),
  success: ({ workSteps }) => ({
    type: types.FETCH_WORK_STEPS_SUCCESS,
    payload: { workSteps },
  }),
  error: notify((error) => ({
    type: types.FETCH_WORK_STEPS_ERROR,
    payload: { error },
  })),
};

export const saveWorkStepToList = {
  add: ({ workStep }) => ({
    type: types.ADD_WORK_STEP,
    payload: { workStep },
  }),
  edit: ({ workStep }) => ({
    type: types.EDIT_WORK_STEP,
    payload: { workStep },
  }),
};

export const deleteWorkStep = {
  request: ({ workStepId }) => ({
    type: types.DELETE_WORK_STEP_REQUEST,
    payload: { workStepId },
  }),
  success: ({ workStepId }) => ({
    type: types.DELETE_WORK_STEP_SUCCESS,
    payload: { workStepId },
  }),
  error: notify((error) => ({
    type: types.DELETE_WORK_STEP_ERROR,
    payload: { error },
  })),
};
